import { Component, Input } from '@angular/core';
import { OnboardingInfos } from '@timechef/features/account/state/account.models';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss'],
  standalone: false,
})
export class OnboardingComponent {
  @Input() data!: OnboardingInfos;
}
